<div>
  <h2>Import Recipient List</h2>
  <div class="import-dialog-content">
   
    <p>1. Upload your contact file in .xlsx or .csv format (maximum size: 15 MB):</p>
    <dl-file-upload (dataToSendImportComp)="onFileUpload($event)" ></dl-file-upload>
    <p>2. Choose a name for your source (this name will be shown in your recipients list overview):</p>
      <owc-input [label]="'Source name'" [formControl]="filename" dlinputvalidation class="source-name-input" />
    <div class = "import-source-msg">
      <span>
        Characters A-Z and a-z
      </span>
      <span>
       {{filename.value.length}}/25
      </span>
    </div>
   
   
   <dl-import-dialog-table></dl-import-dialog-table>
   <div class="import-dialog-actions">
    <owc-button class="cancel-button" (click)="onCancel()"> Cancel
    </owc-button>
   <owc-button color="primary" [disabled] ="importButton" (click)="onImport()">
      Import
    </owc-button>
  </div>
  </div>
  
  </div>
  